export enum TuitionFeeFilterOptionValue {
	ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED = "[0,2500]"
}
